
<div class="w-fit flex flex-col items-centered shrink-0 relative group">
  @if (imgUrl) {
    <img class="rounded-full border " [class]="classes" [src]="imgUrl">
  }

  @if (!imgUrl) {
    <div class="rounded-full border bg-slate-700 flex flex-row justify-center items-center" [class]="classes">
      <h4 [class]="initialsClass" >{{initials}}</h4>
    </div>
  }

</div>


